import "./hb-map.module.css";
import { html } from "lit-html";

export default (user) => html` <div id="hb-map" class="w-full h-full"></div> `;
